import { render, staticRenderFns } from "./applicant-card.vue?vue&type=template&id=23ba8ef4&scoped=true&"
import script from "./applicant-card.vue?vue&type=script&lang=js&"
export * from "./applicant-card.vue?vue&type=script&lang=js&"
import style0 from "./applicant-card.vue?vue&type=style&index=0&id=23ba8ef4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ba8ef4",
  null
  
)

export default component.exports